import React, { useEffect } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import HomeRedirect from "@/components/HomeRedirect";

/**
 * Auditoria 2026-10 — `/pedidos/novo` aberto directamente (link, histórico)
 * por um operador sem `can_create_request` mostrava o formulário inteiro e só
 * falhava no fim, com 403. Agora volta logo à casa e diz porquê. O backend
 * continua a ser a autoridade (create_request recusa com o mesmo texto).
 */
export default function CreateRequestRoute({ children }) {
  const { user } = useAuth();
  // Mesma regra do botão "Novo pedido" (AppShell, Pedidos).
  const allowed = user?.role === "admin" || user?.role === "gestor" || !!user?.permissions?.can_create_request;

  useEffect(() => {
    // `id` fixo: o duplo efeito do StrictMode não gera dois avisos.
    if (user && !allowed) toast.error("Não tem permissão para criar pedidos.", { id: "no-create-permission" });
  }, [user, allowed]);

  if (user && !allowed) return <HomeRedirect />;
  return children;
}
